import { useThemeData } from '@msrceng/theme';
// Exports
// -------
/**
 * Hooks that provides a shared definition for the `activityPersonas` prop of the Fluent UI
 * `ActivityItem` component
 *
 * Usage:
 * ```jsx
 *   const timelineItemPersona = useTimelineItemPersona({ author, isDataLoaded });
 *
 *   <ActivityItem activityPersona={[ timelineItemPersona ]} />
 * ```
 */
export const useTimelineItemPersona = ({ author: { imageUrl, initials } = {}, isDataLoaded, }) => {
    const { theme } = useThemeData();
    return Object.assign(Object.assign({}, (isDataLoaded && { imageUrl })), { coinSize: 42, imageInitials: isDataLoaded ? initials : ' ', initialsColor: isDataLoaded ? '#CCE0FF' : theme === null || theme === void 0 ? void 0 : theme.palette.neutralLighter, initialsTextColor: '#111' });
};
